<template>
<div class="content-wrapper">

    <section class="content">

        <div class="box">
            <div class="box-header with-border">
                <h1 class="box-title"><b>ads.txt</b></h1>
                <pre id="divClipboard">{{bidders}}</pre>
                        
             
            </div>
            <div>

                <div class="box">
                    <div class="box-header with-border">
                        <h1 class="box-title">
                            <b v-if="isOverride">Override AdsTxt For this specific domain.</b>
                            <b v-else>Append ads.txt entries here</b>
                        </h1>
                        <div style="height:100%; display: inline-flex; align-items: center; justify-content: center; margin-left:5px;">
                            <label>Append&nbsp;</label>
                            <el-switch style="margin-bottom: 5px;" active-text="" inactive-text="" active-color="#765CDF" inactive-color="#CDCFD0" v-model="isOverride"></el-switch>
                            <label>&nbspOverride</label>
                        </div>
                        <div>
                            <textarea placeholder="Enter data" rows="4" cols="150" v-model="biddersData" style="border:1px solid black;padding:10px"></textarea>
                            <div><button @click="addData" type="button" class="btn btn-primary" >Submit</button></div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </section>

</div>
</template>

<script>
import axios from 'axios';

export default {

    data() {
        return {
            msg: 'charmi',
            uuid: '',
            domId: '',
            bidders: [],
            biddersData: '',
            isOverride: false,
            initialOverride: false,
        }

    },
    created: function () {
        this.uuid = this.$route.params.uuid;
        this.domId = this.$route.params.domId;
        console.log("uuid and domid", this.uuid, this.domId);
        this.getdata();
        this.getOverrideAXT();
        this.getbidderdata();
    },
    methods: {
        getbidderdata(){
            var api = BASE_URL + `v1/dynamic-bidder-data/${this.uuid}/domain/${this.domId}/`
             axios.get(api).then(res => {
                 this.biddersData = res.data.data[0].dynamic_bidders;
                console.log("res",res);
            })
        },
        getdata() {
            var api = BASE_URL + `v1/ads-txt-publisher/${this.uuid}/domain/${this.domId}/`;
           
            axios.get(api).then(res => {
             
                this.bidders = res.data.data;

            })
        },
        getOverrideAXT() {
            axios.get(BASE_URL + 'v1/domains_features/' + this.domId + '/').then(res => {
                let currOverride = res.data.override_adstxt == "true";
                this.isOverride = currOverride;
                this.initialOverride = currOverride;
                this.domFeatures = res.data;
            })
        },
        setOverrideAXT() {
            axios.put(BASE_URL + 'v1/domains_features/' + this.domId + '/', {
                ...this.domFeatures,
                override_adstxt: this.isOverride.toString(),
            }).then(res => {
                console.log("res", res);
            })
        },
        addData() {
            var api = BASE_URL + `v1/ads-txt-publisher/${this.uuid}/domain/${this.domId}/`;
            let x = {
                biddersData: this.biddersData
            }
            if (this.isOverride !== this.initialOverride)
                this.setOverrideAXT()
            axios.post(api, x)
                .then(res => {
                    console.log("res", res);
                    this.getdata();
                    this.getbidderdata();
                })
        }
    }
}
</script>



// WEBPACK FOOTER //
// AdsText.vue?b7fc1914